export async function connectToFirebase() {
  try {
    await navigator.serviceWorker.register(
      `${window.location.origin}/firebase-messaging-sw.js`,
      {
        scope: `${window.location.origin}/firebase-cloud-messaging-push-scope`,
      },
    );
  } catch (e) {
    console.error(e);
  }
}
